import styled from '@emotion/styled';

import Button from 'components/field/Button';

import { Breakpoints } from 'utils/const.styles';

import Image from '../Image';

export const StyledButton = styled(Button)`
	border: 1px solid var(--border-color);
	background-color: var(--white);

	:hover {
		border: 1px solid var(--blue);
		background-color: var(--white);
	}

	&.checked {
		border: 1px solid var(--blue);
		background-color: var(--background-1);
	}

	&.error {
		border: 1px solid var(--red);
		background-color: var(--red-10);
	}

	&.disabled {
		border: 1px solid var(--border-color);
		background-color: var(--black-disable);
	}
`;

export const StyledCard = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: space-between;
	border-radius: var(--spacing-1);
	padding: 2.5rem;
	gap: 2rem;

	@media ${Breakpoints.mobile} {
		padding: 1rem;
		gap: 1rem;
	}
`;

export const Container = styled.div`
	display: flex;
	flex-direction: row;
	gap: 2.5rem;
	align-items: center;
	min-height: 6rem;

	@media ${Breakpoints.mobile} {
		gap: 1rem;
	}
`;

export const ContentWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
	text-align: start;
`;

export const Title = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 1rem;

	@media ${Breakpoints.mobile} {
		flex-direction: column;
		align-items: start;
	}
`;

export const InputWrapper = styled.div`
	flex-shrink: 0;
`;

export const StyledImage = styled(Image)`
	border-radius: 50%;
`;
